module.exports = __webpack_public_path__ + "img/图5.4a9eb369.png";